/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unsafe-optional-chaining */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { API } from 'api/Api';
import { API_URL } from 'api/ApiUrl';
import { setMessage } from 'redux/common/messageSlice';
import { SEVERITY_ERROR } from 'utils/constants';
import { errorHandler, successHandler } from 'utils/errorHandler';

export const homePageAsync = createAsyncThunk(
    'getHomePage',
    async (data, { dispatch, getState }) => {
        const session = getState();
        const { token, username } = session?.auth?.user;
        try {
            const response = await API.post(
                API_URL.home,
                { username },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    baseIndex: 1,
                },
            );
            // dispatch(setHomePage(response));
            return response;
        } catch (error) {
            dispatch(
                setMessage({
                    message: error.message,
                    severity: SEVERITY_ERROR,
                }),
            );
            return Promise.reject({ payload: error });
        }
    },
);




export const writeValue = createAsyncThunk(
    'writeValue',
    async (data, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;
        try {
            const response = await API.post(
                `${API_URL.writeValue}?email=${email}`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    baseIndex: 0,
                },
            );
            successHandler(dispatch, response.message);
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

